<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
    import Tour360 from "../components/landing/Tour360.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusPresaMadin",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones,
            Tour360
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/instalaciones-Queretaro-1.webp',
                    '/pagesImages/estatua-1.webp',
                    '/pagesImages/teatro-Queretaro-1.webp',
                    '/pagesImages/estatua-2.webp',
                    '/pagesImages/instalaciones-Queretaro-3.webp',
                    '/pagesImages/estatua-3.webp',
                    '/pagesImages/instalaciones-gesel-1.webp',
                    '/pagesImages/estatua-4.webp',
                    '/pagesImages/instalaciones-Queretaro-4.webp',
                ],
                images2: [
                    '/pagesImages/areas-verdes-Queretaro-1.webp',
                    '/pagesImages/canchas-Queretaro-1.webp',
                    '/pagesImages/areas-verdes-Queretaro-2.webp',
                    '/pagesImages/canchas-Queretaro-2.webp',
                    '/pagesImages/areas-verdes-Queretaro-3.webp',
                    '/pagesImages/biblioteca-Queretaro-1.webp',
                    '/pagesImages/cafeteria-Queretaro-1.webp',
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Queretaro-1.webp",
                    "/pagesImages/encabezado-landing-Queretaro-2.webp",
                    "/pagesImages/encabezado-landing-Queretaro-3.webp",
                ],
                altArray: [
                    "Fotos de campus Magno Querétaro",
                    "Fotos de campus Magno Querétaro",
                    "Fotos de campus Magno Querétaro",
                ],
                tour: [
                    { src:"/pagesImages/tour-Queretaro-1.webp", title:"Tour virtual de Campus Querétaro"},
                    { src:"/pagesImages/tour-Queretaro-3.webp", title:"Tour virtual de Campus Querétaro"},
                    { src:"/pagesImages/tour-Queretaro-4.webp", title:"Tour virtual de Campus Querétaro"},
                    { src:"/pagesImages/tour-Queretaro-5.webp", title:"Tour virtual de Campus Querétaro"},
                    { src:"/pagesImages/tour-Queretaro-6.webp", title:"Tour virtual de Campus Querétaro"},
                    { src:"/pagesImages/tour-Queretaro-7.webp", title:"Tour virtual de Campus Querétaro"},
                    { src:"/pagesImages/tour-Queretaro-8.webp", title:"Tour virtual de Campus Querétaro"},
                ],
                campusName: "QUERÉTARO",
                campusType: "CAMPUS MAGNO",
                localidad: "Querétaro",
                frase: "Ejecuta tus conocimientos con la maestría del que sigue aprendiendo",
                autor: "Jonathan García-Allen",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus Magno Querétaro'" :testo1="'En una ciudad con proyección global, este campus es un referente en excelencia académica, formación integral y atención personalizada.'" :testo2="'Está inspirado en la arquitectura griega, donde se ofrece  una experiencia transformadora en un ambiente que fusiona tradición académica con vanguardia educativa.'" :testo3="'Situado en una de las zonas con mejor conectividad de Querétaro, el campus permite combinar los estudios con otros compromisos, debido al fácil acceso de transporte, centros comerciales y zonas residenciales.'" :img="'/pagesImages/una-mirada-Queretaro.webp'" :alt="'Jardín de campus Querétaro'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Es un entorno que combina infraestructura moderna y naturaleza, cuenta con espacios abiertos,<br class="lg:block hidden"> extensas áreas verdes y servicios educativos de primer nivel.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Auditorio</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Espacio para clases de Arte y Teatro, entre otras manifestaciones artísticas, también se realizan eventos culturales, conferencias, encuentros multidisciplinarios, foros, debates y presentaciones.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Salones especiales para asignaturas de Arquitectura, así como cámara Gesell y sala de juicios orales para prácticas profesionales de carreras como Psicología y Derecho.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas y climatizadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas, así como minisplits para aire caliente y frío, asegurando un ambiente cómodo en cualquier estación del año.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Patio de campus Querétaro"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="flex lg:flex-row flex-col items-center justify-center">
                    <div class="flex lg:order-1 order-2 items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        alt="Fotos de instalaciones de campus Querétaro"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] order-1 lg:order-2 text-justify mb-8 lg:mb-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras, la biblioteca fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas verdes y canchas deportivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Este campus está rodeado de áreas verdes que invitan a un estilo de vida saludable y activo, además, cuenta con canchas de futbol, basquetbol y voleibol.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 lg:mb-4 leading-none w-full">Oferta académica en Campus Querétaro</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', ],
        Maestrías: [ 'Psicoterapia con un<br> enfoque Psicoanalítico'],
    }" class="flex items-center justify-center" />
    <!-- <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', 'Arquitectura', 'Diseño Gráfico', 'Arte y Teatro'],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Derecho Fiscal', 'Derecho Penal', 'Psicoterapia con un<br> enfoque Psicoanalítico', 'Mercadotecnia Digital', 'Contabilidad', 'Educación'],
        Doctorados: ['Alta Dirección', 'Derecho', 'Educación']
    }" class="flex items-center justify-center" /> -->
    <section class="flex w-full items-center justify-center my-10">
        <div class="lg:flex w-full max-w-[1200px] justify-center items-center mb-6">
            <div class="flex flex-col md:pr-14 pb-7 md:pb-0 w-full md:w-1/2 items-center md:items-end lg:px-16 px-8">
                <li class="list-none flex flex-col items-center md:items-start">
                    <h3 class="text-center md:text-left line-height-36 text-3xl md:text-4xl text-hgold mb-4 font-serif">Diplomados</h3>
                    <ul class="text-left pl-6 list-disc space-y-1 mb-4">
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Tanatología</a>
                        </li>
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Criminología</a>
                        </li>
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Reforma Judicial</a>
                        </li>
                    </ul>
                </li>
            </div>
            <div class="flex w-full md:w-1/2 justify-center md:justify-start lg:px-0 px-8">
                <img src="/pagesImages/square-docs.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Explora los Diplomados">
            </div>
        </div>
    </section>
    <div class="flex items-center justify-center w-full mb-16 mt-6 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center mb-16 w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo escolarizado</span>
                                </h3>
                                <p class="lg:hyphens-none hyphens-auto">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/modelo-escolarizado-madin.webp" alt="Estudiante modelo escolarizado en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Magno Querétaro.</p>
            <Tour360 :src="'https://tourmkr.com/F1Wc616psA/46684520p&2.9h&86.11t'"  class="w-full mb-12"/>
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">Galería</h2>
            <Instalaciones :items="tour" class="" />
        </div>
    </div>
	<Ubicacion :campus="'Campus Magno Querétaro'" :mapa="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7465.322561617368!2d-100.436808!3d20.683355!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d35b290a785275%3A0xbc657c5e82d44c0c!2sUniversidad%20Humanitas%20Campus%20Quer%C3%A9taro!5e0!3m2!1ses-419!2sus!4v1738217626386!5m2!1ses-419!2sus'" :testo1="'Llegar al Campus Magno Querétaro es sencillo y accesible gracias a su ubicación cercana a la estación Paseo de Jurica. Para llegar en transporte público están habilitadas las siguientes líneas: 98, C-31, C-69, L-159, T-08.'" :ubicacion="'Fracc. de la Parcela No. 126, Zona 6, Paseo de la República C.P. 76226, Jurica, Querétaro.'" :telefono="'442-212-1296'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
